import React, { useEffect, useState, useContext } from 'react';
import Table from 'react-bootstrap/Table';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import UpdateIcon from '@mui/icons-material/Update';
import Tooltip from '@mui/material/Tooltip';
import { NavLink, useParams } from 'react-router-dom';
import { postRequest } from '../../../lib/api';
import { AuthContext } from '../../../authContext/context';
import toast from 'react-hot-toast';
import Pagination from '@mui/material/Pagination';
import { formatDateTime } from '../../../utlis/dateandtime';
import Swal from 'sweetalert2';
import CancelIcon from '@mui/icons-material/Cancel';



export default function AppointmentList() {
  const { id } = useParams();
  const authCtx = useContext(AuthContext);
  const [appointments, setAppointments] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  

  const fetchAppointments = async (pageVal = 1) => {
    try {
      const res = await postRequest(`private/appointmentList/${id}`, {
        page: pageVal,
        limit: 8,
      });
      console.log(res , 'response@123')
      if (res?.status === 200 && res?.data?.docs) {
        setAppointments(res.data.docs);
        setTotalPages(res.data.totalPages || 1);
      } else {
        toast.error(res?.message || 'Failed to fetch appointments');
        setAppointments([]);
        setTotalPages(1);
      }
    } catch (err) {
      toast.error('Something went wrong');
      setAppointments([]);
      setTotalPages(1);
    }
  };

const handleDelete = async (appointmentId) => {
  const result = await Swal.fire({
    title: 'Are you sure?',
    text: 'Do you want to delete this appointment?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#bb0000',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!'
  });

  if (result.isConfirmed) {
    try {
      const res = await postRequest(`private/deleteAppointment/${appointmentId}`, {}, authCtx.token);
      if (res?.status === 200) {
        //toast.success(res.message || "Appointment deleted successfully");
        fetchAppointments(page); // refresh the list
      } else {
        //toast.error(res?.message || "Failed to delete appointment");
      }
    } catch (err) {
      //toast.error("Something went wrong while deleting");
    }
  }
};

const handleCancel = async (appointmentId) => {
  const { value: reason } = await Swal.fire({
    title: 'Cancel Appointment',
    input: 'textarea',
    inputLabel: 'Reason for Cancellation',
    inputPlaceholder: 'Type your reason here...',
    inputAttributes: {
      'aria-label': 'Type your reason here'
    },
    showCancelButton: true,
    confirmButtonText: 'Submit',
    confirmButtonColor: '#bb0000',
  });

  if (reason) {
    try {
      const res = await postRequest(`private/cancelAppointment/${appointmentId}`, {
        cancel_reason: reason,
      }, authCtx.token);

      if (res?.status === 200) {
        toast.success(res.message || 'Appointment cancelled successfully');
        fetchAppointments(page); // refresh list
      } else {
        toast.error(res?.message || 'Failed to cancel appointment');
      }
    } catch (err) {
      toast.error('Something went wrong while cancelling');
    }
  }
};


  useEffect(() => {
    if (id) fetchAppointments(page);
  }, [id, page]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  return (
    <div className='mt-4'>
      <Table striped responsive bordered>
        <thead>
          <tr>
            <th colSpan={8} className='bg-grey'>Appointments</th>
          </tr>
          <tr>
            <th>Name</th>
            <th>Date / Time</th>
            <th>TI Case Ref</th>
            <th>Booked</th>
            <th>Status</th>
            <th>Appointments Notes</th>
            <th>Appointments Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {appointments.length === 0 ? (
            <tr>
              <td colSpan={8} className="text-center">No appointments found</td>
            </tr>
          ) : (
            appointments.map((item, idx) => (
                
              <tr key={idx}>
                <td>{item?.fullname || '-'}</td>
                <td>{formatDateTime(item.createdAt).date}</td>
                <td>{item?.ti_case_ref || '-'}</td>
                <td>
      {item?.appointmentDate ? formatDateTime(item.appointmentDate).date : '-'} {formatDateTime(item.appointmentDate).time} by {item?.creation_username || '-'}
    </td>
              <td>
  <span
    style={{
      color: item?.status == 'Active' ? 'green' : 'red',
      fontWeight: 600,
    }}
  >
    {item?.status || '-'}
  </span>
</td>


                <td>{item?.note || '-'}</td>
               <td>
  {item?.appointmentDate ? (
    <>
      {formatDateTime(item.appointmentDate).date} <br />
      {formatDateTime(item.appointmentDate).time}
    </>
  ) : '-'}
</td>

                <td>
                  <NavLink to={`/customers/appointment/reschedule/${item._id}`} state={{
    fullname: item?.fullname,
    //date: item?.createdAt?.date,
    ti_case_ref: item?.ti_case_ref
  }} className="red-link-text cursor-pointer w-18">
                    <Tooltip title="Reschedule"><UpdateIcon /></Tooltip>
                  </NavLink>
                  &nbsp;&nbsp;&nbsp;

                  {item?.status !== 'cancel'&& <span
    className="red-link-text cursor-pointer w-18"
    onClick={() => handleCancel(item._id)}
  >
    <Tooltip title="Cancel"><CancelIcon /></Tooltip>
                   </span>}
       
                  {/* <NavLink to={`/customers/edit/appoitment/${item._id}`} className="red-link-text cursor-pointer w-18">
                    <Tooltip title="Edit"><EditOutlinedIcon /></Tooltip>
                  </NavLink> */}
                  &nbsp;&nbsp;&nbsp;
               <span
  className="red-link-text cursor-pointer w-18"
  onClick={() => handleDelete(item._id)}
>
  <Tooltip title="Delete"><DeleteOutlineOutlinedIcon /></Tooltip>
</span>

                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>

      {appointments.length > 0 && (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={handlePageChange}
            color="primary"
            shape="rounded"
            size="medium"
          sx={{
                '& .Mui-selected': {
                  background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%) !important',
                  color: '#fff !important',
                },
                '& .MuiPaginationItem-root': {
                  color: 'var(--bs-red-color)',
                  borderColor: 'var(--bs-red-color)',
                },
              }}
          />
        </div>
      )}
    </div>
  );
}
